import { call, select } from 'redux-saga/effects';
import { selectCurrentSystemRole } from 'features/application/selectors';
import { SystemRole } from 'features/room/types';
import { initSentry } from 'features/application/initSentry';

export function* initSentrySaga() {
  const systemRole: SystemRole | null = yield select(selectCurrentSystemRole);

  yield call(initSentry, systemRole);
}
